export var CHARACTER_WIDTH = 12;
export var ICON_OFFSET = 20;